import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType } from '../../constants';

export class GaTrackingZRPOtherBucketsViewedEventModel implements GATrackingEvent {
  constructor(private payload: { action: GATrackingEventType; element: string }) {}

  getEventActionFromPage(): any {
    return `${this.payload.action} viewed`;
  }

  getEventType(): GATrackingEventType {
    return this.getEventActionFromPage();
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: 'bucket_viewed',
      label: this.payload.element,
    };
  }
}
